import React from 'react'
import { useState, useEffect, useRef } from 'react';
import ReadMore from '../../../components/ReadMoreText';
import useOnScreen from '../../../components/useOnScreen';
import { getSponsors } from '../../../crud/dedicatedEvent-crud';
import { sampleSponsorsData } from '../../../data/sampleEvent';
import { errorToaster } from '../../../helpers/utils';
import Image from 'next/image';

const imageStyle = {
    width: '100%',
    height: 'auto',
    borderRadius: "8px",
    border: "0.8px solid #CACACA"
}

const EventSponsorsMinimalistic = ({ eventUrl, eventData, setCurrSection, samplePage }) => {

    const [sponsors, setsponsors] = useState(null);

    const ref = useRef(null)



    const getAllsponsors = async () => {
        try {
            const res = await getSponsors(eventUrl);
            setsponsors(res.data);
        } catch (error) {
            errorToaster("Something went wrong while trying to get ticket, please try again later");
        }
    }

    useEffect(() => {
        if (samplePage) {
            setsponsors(sampleSponsorsData)
        } else {
            getAllsponsors();
        }
    }, [eventUrl])

    return (
        <>
            <section id='sponsors' ref={ref}>
                <div className='content mb-5'>
                    <div className='head'>
                        <h2 className=' m-0' style={{ fontSize: "20px", color: '#000' }}>{eventData?.sponsor_section_title ? eventData?.sponsor_section_title.toUpperCase() : 'SPONSORS'}</h2>
                    </div>
                    {
                        eventData?.sponsor_section_description &&
                        <div className={`mt-4 speaker_section_description`}>
                            <div
                                dangerouslySetInnerHTML={{ __html: eventData.sponsor_section_description?.replace(/(?:\r\n|\r|\n)/g, '') || '' }}
                                style={{
                                    fontFamily: "Manrope",
                                    fontSize: "14px",
                                    color: '#000'
                                }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    }
                    <div className='d-flex mt-4 flex-column'>

                        <div className='row sponsors'>
                            {sponsors?.uncategorized && sponsors.uncategorized.map((e) => (
                                <div className='col-6 col-lg-3 col-xl-3 col-xxl-3' style={{ background: "#ffffff" }}>
                                    <Image
                                        src={e.image_url}
                                        onClick={e?.website_url ? () => window.open(e.website_url, '_blank') : () => { }}
                                        alt={e.entity_name}
                                        className='mb-3 sponsor-img'
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={imageStyle}
                                    />
                                </div>
                            ))}
                        </div>

                        {sponsors?.categorized && sponsors.categorized.map(item => (
                            <>
                                <div className='d-flex mb-3'>

                                    <p className='mt-3 type-heading d-inline-block m-0'>{item.category_name.toUpperCase()}</p><hr className='line  flex-grow-1 d-sm-inline-block w-100 my-auto ms-3 d-none '></hr>

                                </div>
                                <div className='row mb-sm-3 mb-2'>
                                    {item?.entity && item.entity.map((e) => (
                                        <div className='col-6 col-lg-4 col-xl-4 col-xxl-3'>
                                            <img
                                                src={e.image_url}
                                                onClick={e?.website_url ? () => window.open(e.website_url, '_blank') : () => { }}
                                                alt={e.entity_name}
                                                className='mb-3 sponsor-img'
                                                style={imageStyle}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </>
                        ))}

                    </div>
                </div>
            </section>
            <style jsx>{`
                .type-heading{
                    font-weight: 600;
                    word-break: normal !important;
                    color:#000;
                    white-space:nowrap;
                    font-size: 16px;
                    font-family: Manrope;    

                }
                .sponsor-img {
                    cursor: pointer;
                }

                .line {
                    border: 0.8px solid #B4B4B4;
                }
                @media only screen and (max-width: 576px) {
                    .type-heading{
                        font-size:16px;
                        font-weight:600;
                    }
                }

                @media (max-width: 754px) {
                    .line {
                        display: none !important;
                    }
                    h2{
                        font-size: 20px;
                    }

                }
            `}</style>
        </>
    )
}

export default EventSponsorsMinimalistic